import * as m from 'mithril';

import LocationFilterList from "./LocationFilterList";
import { NavBar } from '../../components/NavBar';
import { MessageProvider } from '../../context/AppMessages';
import AppContext from '../../context/AppContext';
import buildLanguageChangeActions from '../common/LanguageNavActions';
import { LocationDTO } from '../../apiclient/ApiDtos';

interface Attrs {
    appContext: AppContext,
    messageProvider: MessageProvider,
    title: string,
    locations: LocationDTO[],
    onLocationSelected: (location: LocationDTO) => void,
    //onLanguageChange: (lang: string) => void,
    onClose: () => void
}

export default function LocationSelectionPage(): m.Component<Attrs> {
    return {
        view(vnode) {
            let langChangeActionItems = buildLanguageChangeActions(vnode.attrs.appContext);

            return [
                m('div', { class: 'app-layout bg'}, [
                    m(NavBar, {
                        title: vnode.attrs.title,
                        canBackPress: true,
                        onBackPressed: () => { vnode.attrs.onClose(); },
                        actionItems: langChangeActionItems
                    }),
                    m("div.app-area-main",
                        m(LocationFilterList, {
                            currentLang: vnode.attrs.messageProvider.getCurrentLang(),
                            locations: vnode.attrs.locations,
                            onLocationSelected: (location: LocationDTO) => {
                                //console.log("LocationFilterList.onLocationSelected", location);
                                vnode.attrs.onLocationSelected(location);
                            }
                        })
                    )
                ])
                
            ];
        }
    }
}